<template>
  <div
    class="input"
    :class="[`input--${type}`]"
    @click="focus()"
  >
    <div class="input__wrapper">
      <component
        :is="inputType"
        ref="input"
        class="input__field"
        :type="type"
        spellcheck="false"
        :autocomplete="autocomplete ? 'on' : 'disabled'"
        :value.prop="valueModel"
        :placeholder="placeholder"
        :disabled="disabled"
        v-bind="$attrs"
        v-on="listeners"
        @input="valueModel = $event.currentTarget.value"
        @focus="onFocus"
        @blur="onBlur"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VInput',
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: [String, Number],
      default: undefined,
    },
    mask: {
      type: [Object, String],
      default: undefined,
    },
    autocomplete: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    inputType() {
      if (this.type === 'textarea') {
        return this.type;
      }

      return 'input';
    },
    listeners() {
      return Object.keys(this.$listeners)
        .filter((key) => key !== 'input' && key !== 'focus' && key !== 'blur')
        .reduce((obj, key) => {
          obj[key] = this.$listeners[key];
          return obj;
        }, {});
    },
    valueModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.applyMask();
  },
  beforeDestroy() {
    this.removeMask();
  },
  methods: {
    isMaskAvailable() {
      return this.mask && this.$inputMask;
    },
    applyMask() {
      if (!this.isMaskAvailable()) {return;}

      const mask =
        typeof this.mask === 'object'
          ? this.mask
          : {
            mask: this.mask,
          };

      this.$inputMask({
        autoUnmask: true,
        onincomplete: this.onMaskIncomplete.bind(this),
        mask,
      }).mask(this.$refs.input);
    },
    removeMask() {
      if (!this.isMaskAvailable()) {return;}

      // Remove mask from input
      if (this.$refs.input.inputmask) {
        this.$refs.input.inputmask.remove();
      }
    },
    onMaskIncomplete() {
      this.$refs.input.value = '';
    },
    focus() {
      this.$refs.input.focus();
    },
    onBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
    },
    onFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
  },
};
</script>

<style lang="scss" src="./style.scss"></style>
